<!-- Lista aplicações -->
<p class="text-center" ng-show="applications && !applications.length && !loadingAplicacoes">
  <small>Nenhuma aplicação...</small>
</p>

<span class="input-group-addon no-border no-background" ng-show="loadingAplicacoes">
  <i class="fa fa-spinner fa-spin"></i>
</span>

<uib-accordion id="list-application-history" ng-show="applications.length">
  <div infinite-scroll="getApplications()"
       infinite-scroll-parent="true">
    <div ng-repeat="application in applications | filter:applicationStatusFilter" class="card-list">
      <uib-accordion-group id="{{getCardApplicationId(application)}}" class="panel-default panel-aplicacoes aplicacoes-bg" is-open="application.open">
        <uib-accordion-heading>
          <div prevent-event>
            <h3>
              <button class="close"
                uib-tooltip="{{application.pendente ? 'Aguardando sincronização com o AgroGestão' : 'Excluir aplicação'}}"
                tooltip-placement="left"
                ng-show="application.open"
                ng-if="canManage(application)"
                ng-disabled="application.pendente"
                ng-click="remover(application)">
                <i class="fa fa-trash"></i>
              </button>
              <button
                class="close"
                uib-tooltip="{{application.pendente ? 'Aguardando sincronização com o AgroGestão' : 'Editar aplicação'}}"
                tooltip-placement="left"
                ng-show="application.open"
                ng-if="canManage(application)"
                ng-disabled="application.pendente"
                ng-click="edit(application)"
              >
                <i class="fa fa-edit"></i>
              </button>
            </h3>
            <div ng-hide="applicationsFilters.gleba">
              <h3>
                <strong>{{::application.gleba.descricao | capitalize}}</strong>
                <span ng-class="{'text-danger': isOpened(application) && application.classificacao.area}">(
                  <span style="margin-left:-5px;" ng-class="{'text-danger': isOpened(application) && application.classificacao.nr_tanques}">
                    <ng-pluralize count="+application.nr_tanques"
                      when="{'1': '1 tanque aplicado em ',
                             'other': '{{application.nr_tanques}} tanques aplicados em '}">
                    </ng-pluralize>
                  </span>
                {{::application.area | number:2}}ha)</span>
                <ng-include src="'status-icons.html'"></ng-include>
              </h3>

              <h5 class="text-cinza no-margin" ng-if="application.adubacaoSistema">
                Adubação de Sistema
              </h5>

              <h5 class="text-cinza" ng-show="!applicationsFilters.grupoInsumo">
                {{::application.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
              </h5>

              <h5 ng-show="applicationsFilters.grupoInsumo"
                  ng-include="'datas-aplicacao.html'">
              </h5>
            </div>
            <div ng-show="applicationsFilters.gleba">
              <h3 ng-hide="applicationsFilters.grupoInsumo">
                {{::application.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
                <ng-include src="'status-icons.html'"></ng-include>
              </h3>

              <h3 ng-show="applicationsFilters.grupoInsumo" class="datas-aplicacao-com-status">
                <ng-include src="'datas-aplicacao.html'"></ng-include>
                <ng-include src="'status-icons.html'"></ng-include>
              </h3>
            </div>
            <div ng-hide="applicationsFilters.grupoInsumo" class="float-data"
                 ng-include="'datas-aplicacao.html'">
            </div>
          </div>

          <div class="arrow-expand-card text-cinza" ng-click="openApplicationDetail($event, application)" ng-show="!application.loading">
            <span ng-hide="application.open">
              ver mais&nbsp;
              <i class="glyphicon pointer glyphicon-chevron-down"></i>
            </span>
            <span ng-show="application.open">
              ver menos&nbsp;
              <i class="glyphicon pointer glyphicon-chevron-up"></i>
            </span>
          </div>

          <div class="arrow-expand-card text-cinza" ng-show="application.loading">
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </div>
          <div class="clearfix"></div>
        </uib-accordion-heading>

        <p>
          <span>
            Código: <strong>{{::application.allData.id}}</strong>
            <br>
          </span>

          <span ng-show="applicationsFilters.gleba" ng-class="{'text-danger': isOpened(application) && application.classificacao.area}">
            Área Aplicada: <strong>{{::application.area | number:2}}ha</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.operador">
            Operador: <strong>{{::application.allData.atributo.operador.nome | capitalize}}</strong>
            <br>
          </span>

          <span ng-show="application.allData.atividade">
            Cultura: <strong>{{::application.allData.atividade.descricao | capitalize}}</strong>
            <br>
          </span>

          <span ng-show="application.allData.estadio">
            Estádio: <b>{{::application.allData.estadio.abreviatura}}</b> - {{::application.allData.estadio.descricao | capitalize}}
            <br>
          </span>

          <span ng-show="application.allData.maquinaDescricao">
            Máquina: <strong>{{::application.allData.maquinaDescricao}}</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.iniciado_em"
                ng-class="{'text-danger': isOpened(application) && application.classificacao.dtIni}">
            Iniciada em <strong>{{::application.allData.atributo.iniciado_em | date:'dd/MM \'às\' HH:mm'}}</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.encerrado_em"
                ng-class="{'text-danger': isOpened(application) && application.classificacao.dtFim}">
            Encerrada em <strong>{{::application.allData.atributo.encerrado_em | date:'dd/MM \'às\' HH:mm'}}</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.tempo_decorrido">
            Tempo Decorrido: <strong>{{getDurationFromSeconds(application.allData.atributo.tempo_decorrido)}}</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.temperatura_final" ng-class="{'text-danger': application.classificacao.temperaturaFinal}">
            Temperatura: <strong>{{application.allData.atributo.temperatura_final | number}}ºC</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.velocidade_maxima_vento" ng-class="{'text-danger': application.classificacao.velocidadeVento}">
            Velocidade do vento: <strong>{{application.allData.atributo.velocidade_maxima_vento | number:1}}km/h</strong>
            <br>
          </span>

          <span ng-show="application.allData.atributo.umidade_final" ng-class="{'text-danger': application.classificacao.umidadeFinal}">
            Umidade relativa do ar: <strong>{{application.allData.atributo.umidade_final | number}}%</strong>
            <br>
          </span>
          <span ng-show="application.allData.atributo.horas_sem_chuva" ng-class="{'text-danger': application.classificacao.horasSemChuva}">
            Horas sem chuva: <strong>{{application.allData.atributo.horas_sem_chuva | number}}</strong>
            <br>
          </span>
          <span ng-show="application.allData.vazao" ng-class="{'text-danger': application.classificacao.vazao}">
            Vazão: <strong>{{application.allData.vazao | number}} l/ha</strong>
            <br>
          </span>
          <span ng-show="application.allData.bico" ng-class="{'text-danger': application.classificacao.bico}">
            Bico: <strong>{{application.allData.bico}}</strong>
            <br>
          </span>
          <span ng-show="application.allData.obs">
            Observações: <strong>{{application.allData.obs}}</strong>
            <br>
          </span>
        </p>

        <span class="area-demarcada pointer" ng-click="showAreaDemarcada(application)" ng-show="application.allData.has_area_demarcada">
          <i class="fa fa-map"></i>
          Área demarcada
        </span>
        <div class="weather-charts" ng-show="showWeather">
          <uib-accordion>
            <uib-accordion-group class="panel-default" is-open="application.showWeatherChart">
              <uib-accordion-heading>
                <span ng-click="loadWeatherChart(application)">
                  <i class="fa fa-bar-chart"></i>
                  Gráficos meteorológicos
                </span>
              </uib-accordion-heading>
              <div ng-show="application.chart.data.Wf.length" google-chart chart="application.chart"></div>
              <div class="alert alert-info" ng-show="!application.chart.data.Wf.length && !application.loading">Não há dados meteorológicos disponíveis.</div>
              <p class="text-cinza text-center" ng-show="application.loading">
                <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
              </p>
            </uib-accordion-group>
          </uib-accordion>
        </div>

        <table class="table-card">
          <thead>
            <tr>
              <th>Produto</th>
              <th class="text-right">Dose</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="produto in application.allData.itens track by $index" class="f-size-11"
                ng-class="{'text-danger': isOpened(application) && application.classificacao.itensAplicacao[$index].produto}">
              <td class="vertical-middle padding-bottom-5">
                {{::produto.descricao}}
                <span ng-if="produto.qt_area != application.area">({{::produto.qt_area | number:2}} ha)</span>
              </td>
              <td class="vertical-middle text-right padding-left-5 padding-bottom-5"
                  ng-class="{'text-danger': isOpened(application) && application.classificacao.itensAplicacao[$index].dose}">
                {{produto.qt_dose | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}/ha
              </td>
              <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                {{produto.qt_total | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}
              </td>
            </tr>
          </tbody>
        </table>

        <a class="btn-xs btn-link text-info" ng-if="hasTelemetryData(application)" ng-href="{{telemetryUrl(application)}}" target="_blank">
          <i class="fa fa-signal"></i>
          Telemetria
        </a>

        <button type="button" class="btn-xs btn-link text-info" ng-click="showRastroMaquina(application)" ng-disabled="application.polylines && application.polylines.length < 1">
          <span ng-if="!application.polylines || application.polylines.length > 0">Visualizar rastro da máquina</span>
          <span ng-if="application.polylines.length < 1">Não há rastros para exibir</span>
        </button>

        <span ng-print print-element-id="print-aplicacao-{{application.id}}">
          <button type="button" class="btn-xs btn-link text-info" ng-click="appWrap.preparePrint(application, $event)">
            <i class="fa fa-print" ng-hide="application.loadingRecommendation"></i>
            <i class="fa fa-spinner fa-pulse fa-fw" ng-show="application.loadingRecommendation"></i>
            Imprimir aplicação
          </button>
        </span>

        <ng-include src="'views/painel_propriedade/print_aplicacao.html'"></ng-include>

      </uib-accordion-group>

      <p class="left-border-card">
        <span class="pointer" ng-show="application.open" ng-click="openRecommendationDetail(event, application)">
          ver recomendação
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </span>
      </p>

      <div id="{{getSubCardApplicationId(application)}}" class="subcard-recommendation subcard-left panel-heading" ng-show="isOpened(application)">
        <p class="left-border-card">
          <span class="pointer" ng-click="openRecommendationDetail(event, application)">
            esconder
            <i class="fa fa-chevron-up" aria-hidden="true"></i>
          </span>
        </p>

        <div>
          <h3 class="text-center">Recomendação</h3>

          <div class="text-center" ng-show="application.loadingRecommendation">
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </div>

          <h5 class="text-center" ng-show="!application.loadingRecommendation && !application.recommendation.id">
            Nenhuma recomendação vinculada
          </h5>

          <div ng-show="!application.loadingRecommendation && application.recommendation.id">
            <h5 class="text-cinza">
              {{::application.recommendation.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
            </h5>

            <span>
              Código: <strong>{{::application.recommendation.id}}</strong>
              <br>
            </span>
            
            <p>
              <span ng-show="!application.recommendation.adubos">
                Período: <strong>{{::application.recommendation.data_inicio | date:'dd/MM/yy'}} a {{::application.recommendation.data_termino | date:'dd/MM/yy'}}</strong>
                <br>
              </span>
              <span ng-if="application.recommendation && application.recommendation.adubos">
                Período: <strong>{{::getRecommendationDataInicio(application) | date:'dd/MM/yy'}} a {{::getRecommendationDataFim(application) | date:'dd/MM/yy'}}</strong>
                <br>
              </span>
              Recomendante: <strong>{{::(application.recommendation.recomendante || application.recommendation.usuario).nome_completo | capitalize}}</strong>
              <br>
              Área: <strong>{{::(application.recommendation.area || application.recommendation.gleba.area_total) | number:2}}ha</strong>
              <br>

              <span ng-show="application.recommendation.temperatura.minima">
                Temperatura acima de: <strong>{{::application.recommendation.temperatura.minima | number:0}}°C</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.temperatura.maxima">
                Temperatura abaixo de: <strong>{{::application.recommendation.temperatura.maxima | number:0}}°C</strong>
                <br>
              </span>

              <span ng-show="application.recommendation.umidade.minima">
                Umidade acima de: <strong>{{::application.recommendation.umidade.minima | number:0}}%</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.umidade.maxima">
                Umidade abaixo de: <strong>{{::application.recommendation.umidade.maxima | number:0}}%</strong>
                <br>
              </span>

              <span ng-show="application.recommendation.vento.maxima">
                Velocidade do vento: <strong>{{::application.recommendation.vento.maxima | number:1}}</strong>
                <br>
              </span>

              <span ng-show="application.recommendation.horas_sem_chuva">
                Horas sem Chuva: <strong>{{::application.recommendation.horas_sem_chuva | number:0}}</strong>
                <br>
              </span>

              <span ng-show="application.recommendation.velocidade.minima">
                Velocidade mínima: <strong>{{::application.recommendation.velocidade.minima | number:0}} km/h</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.velocidade.maxima">
                Velocidade máxima: <strong>{{::application.recommendation.velocidade.maxima | number:0}} km/h</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.parametro.velocidade_minima">
                Velocidade mínima: <strong>{{::application.recommendation.parametro.velocidade_minima | number:0}} km/h</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.parametro.velocidade_maxima">
                Velocidade máxima: <strong>{{::application.recommendation.parametro.velocidade_maxima | number:0}} km/h</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.parametro.velocidade_maxima_vento">
                Velocidade vento: <strong>{{::application.recommendation.parametro.velocidade_maxima_vento | number:0}} km/h</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.vazao">
                Vazão: <strong>{{::application.recommendation.vazao | number:0}} l/ha</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.bico">
                Bico: <strong>{{::application.recommendation.bico}}</strong>
                <br>
              </span>
              <span ng-show="application.recommendation.observacao">
                Observações: <strong>{{::application.recommendation.observacao | capitalize}}</strong>
                <br>
              </span>
            </p>

            <table class="table-card">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th class="text-right">Dose</th>
                  <th class="text-right">Total</th>
                  <th class="text-right">Aplicado</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="produto in getRecommendationProducts(application) track by $index" class="f-size-11"
                    ng-class="{'text-danger': isOpened(application) && application.classificacao.insumosRecomendacao[$index].produto}">
                  <td class="vertical-middle padding-bottom-5">
                    {{::((produto.produto || produto).descricao || (produtos.produto || produto).id)}}
                  </td>
                  <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                    {{(produto.dose || produto.qt_dose) | formatDynamicDecimals}} {{::produto.unidade.abreviatura | lowercase}}/ha
                  </td>
                  <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                    {{calculateTotalProduto(produto, produto.area || application.recommendation.gleba.area_recomendada || application.recommendation.gleba.area_total, (application.recommendation.glebas || []).length > 1) | formatDynamicDecimals}} {{::produto.unidade.abreviatura | lowercase}}
                  </td>
                  <td class="vertical-middle text-right padding-left-5 padding-bottom-5">
                    {{::application.classificacao.insumosRecomendacao[$index].aplicado | number:1}}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</uib-accordion>
<!-- Fim lista recomendacoes-->
